import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { LoginRedirect } from "./modules/shared/services/login-redirect.service";
import { EnsureAuthenticated } from "./modules/shared/services/ensure-authenticated.service";
import { KlNotFoundComponent } from "@app/modules/shared/components/kl-not-found/kl-not-found.component";
import { KlReportViewerComponent } from "@app/modules/shared/components/kl-report-viewer/kl-report-viewer.component";
import { KlReportDesignerComponent } from "@app/modules/shared/components/kl-report-designer/kl-report-designer.component";
import { LockScreenComponent } from "@app/modules/shared/components/lock-screen/lock-screen.component";

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("app/modules/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
        canActivate: [EnsureAuthenticated],
      },
      {
        path: "auth",
        loadChildren: () =>
          import("app/modules/authentication/authentication.module").then(
            (m) => m.AuthenticationModule
          ),
        canActivate: [LoginRedirect],
      },
      {
        path: "report-viewer",
        component: KlReportViewerComponent,
        canActivate: [EnsureAuthenticated],
      },
      {
        path: "report-designer",
        component: KlReportDesignerComponent,
        canActivate: [EnsureAuthenticated],
      },
      {
        path: "not-found",
        component: KlNotFoundComponent,
      },
      {
        path: "lock-screen",
        component: LockScreenComponent,
      },
      {
        path: "**",
        redirectTo: "not-found",
      },
    ]),
  ],
  exports: [RouterModule],
})
export class RoutingModule {}
